import { HQ } from "./sportConfig";
export const BRAND = HQ.brand;
export const PUBLIC_ORIGIN = window.location.origin + HQ.basename;
export const HOCKEY = HQ.sport === "hockey";

export const FOOTBALL = HQ.sport === "football";
